import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextSummary',
    props: {
        maxLength: { default: 150 },
        description: null,
        oneLineSummary: { type: Boolean },
        noExpand: { type: Boolean },
        component: { default: "p" }
    },
    setup(__props) {
        const props = __props;
        library.add(faChevronUp, faChevronDown);
        const showDetails = ref(false);
        const textTooLong = computed(() => props.description.length > props.maxLength);
        const text = computed(() => textTooLong.value && !showDetails.value
            ? props.description.slice(0, Math.round(props.maxLength - props.maxLength / 2)) + "..."
            : props.description);
        return { __sfc: true, props, showDetails, textTooLong, text, FontAwesomeIcon };
    }
});
